import React, { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import styled from 'styled-components';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';

import { API_URL, ORDER_STATUS_COLORS } from '../../../../utils/constants';
import { CreatedOnCell } from '../../../../components/common/grid/Cells';
import { DateRangeFilterCell } from '~/src/components/common/grid/DateRangeFilterCell';

import createIcon from '../../../../static/img/createIcon.svg';
import GridWrapper from '~/src/components/common/GridWrapper';

const StatusDot = styled.span<{ color: string }>`
  height: 13px;
  width: 13px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  border: 1px solid grey;
  display: inline-block;
  margin-right: 8px;
`;

export default function OrdersList(): JSX.Element {
  const stateRef = useRef(null);
  const history = useHistory();
  const url = `${API_URL}/orders/get-without-consolidation`;

  const StatefullGrid = withState(Grid, url);

  const CustomerNameCell = (row, ref) => {
    const { dataItem } = row;
    return (
      <td>
        <Link to={`/orders/edit/${dataItem.id}`}>{dataItem?.customerName ?? 'FNB.BG'}</Link>
      </td>
    );
  };

  const WarehouseOwnerCell = (row) => {
    const { dataItem } = row;
    return (
      <td>
        <Link to={`/orders/edit/${dataItem.id}`}>{dataItem?.warehouseOwnerName}</Link>
      </td>
    );
  };

  const OrderNumberCell = (row) => {
    const { dataItem } = row;
    return (
      <td>
        <Link to={`/orders/edit/${dataItem.id}`}>{dataItem?.orderNumber}</Link>
      </td>
    );
  };

  const OrderStatusCell = (row) => {
    const { dataItem } = row;
    const status = dataItem?.sellOrderStatus;
    const statusKey = status.replace(/\s+/g, '') as keyof typeof ORDER_STATUS_COLORS;
    const color = ORDER_STATUS_COLORS[statusKey] || '#000';
    return (
      <td>
        <Link to={`/orders/edit/${dataItem.id}`}>
          <StatusDot color={color} />
          {status}
        </Link>
      </td>
    );
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Orders"
        titleRight="Create order"
        onRightHandler={(): void => history.push('/orders/create')}
        iconRight={createIcon}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="createdOn" title="Date" cell={CreatedOnCell} filterCell={DateRangeFilterCell} />
          <GridColumn field="warehouseOwnerName" title="Warehouse Owner" cell={(row) => WarehouseOwnerCell(row)} />
          <GridColumn field="customerName" title="Customer" cell={(row) => CustomerNameCell(row, stateRef)} />
          <GridColumn field="orderNumber" title="Svila Order" cell={(row) => OrderNumberCell(row, stateRef)} />
          {/* <GridColumn field="FnbNumber" title="Fnb Order" cell={(row) => FnbOrderNumberCell(row, stateRef)} /> */}
          <GridColumn field="shippingType" title="Shipping Type" />
          <GridColumn
            field="sellOrderStatus"
            title="Status"
            cell={(row) => OrderStatusCell(row, stateRef)}
            sortable={false}
            filterable={false}
          />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}